/* AIRDRAGON Site-Sections: Duftfamilien-Tabs, Kollektionsfilter, Sortierung. Ohne Abhängigkeiten. */
(function () {
  'use strict';

  /* ---------- Tabs (Duftfamilien auf der Startseite) ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  /* ---------- Kollektion: Duftfamilien-Filter (clientseitig) ---------- */
  function initFilter(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ads-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-family]'));
    var countEl = root.querySelector('[data-ads-count]');
    if (!buttons.length || !cards.length) return;
    function apply(value, updateUrl) {
      var shown = 0;
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ads-filter') === value ? 'true' : 'false'); });
      cards.forEach(function (c) {
        var match = value === '' || c.getAttribute('data-family') === value;
        c.hidden = !match;
        if (match) shown++;
      });
      if (countEl) countEl.textContent = countEl.getAttribute('data-template').replace('{n}', shown);
      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (value) url.searchParams.set('familie', value); else url.searchParams.delete('familie');
        window.history.replaceState({}, '', url.toString());
      }
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-ads-filter'), true); });
    });
    var initial = new URL(window.location.href).searchParams.get('familie');
    if (initial && buttons.some(function (b) { return b.getAttribute('data-ads-filter') === initial; })) apply(initial, false);
  }

  /* ---------- Kollektion: Sortierung ---------- */
  function initSort(root) {
    var select = root.querySelector('[data-ads-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-ads-tabs]').forEach(initTabs);
    s.querySelectorAll('[data-ads-collection]').forEach(function (r) { initFilter(r); initSort(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
